// Diagnostika natijalari shu qurilmaning brauzerida saqlanadi (localStorage).
// Tuzilishi: { [talabaKaliti]: { name, group, pre: {scores, overall, date}, post: {...} } }
const KEY = "mushtariy_diagnostics";
const CURRENT_KEY = "mushtariy_current_student";

export const studentKey = (name, group) =>
    `${name.trim().toLowerCase()}|${(group || "").trim().toLowerCase()}`;

export const loadAll = () => {
    try {
        return JSON.parse(localStorage.getItem(KEY)) || {};
    } catch {
        return {};
    }
};

export const saveResult = (name, group, stage, result) => {
    const all = loadAll();
    const k = studentKey(name, group);
    all[k] = { ...(all[k] || {}), name: name.trim(), group: group.trim(), [stage]: result };
    try {
        localStorage.setItem(KEY, JSON.stringify(all));
        localStorage.setItem(CURRENT_KEY, k);
    } catch {
        // saqlash imkoni bo'lmasa ham natija ekranda ko'rsatiladi
    }
    return all[k];
};

export const loadCurrent = () => {
    try {
        const k = localStorage.getItem(CURRENT_KEY);
        return k ? loadAll()[k] || null : null;
    } catch {
        return null;
    }
};

export const removeStudent = (k) => {
    const all = loadAll();
    delete all[k];
    try {
        localStorage.setItem(KEY, JSON.stringify(all));
    } catch {
        // e'tiborsiz
    }
    return all;
};
